import React, { useEffect } from "react";
import PickListView from "presentational/portfolio/PickListView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";

function PickList(props) {
  const {
    outfitList,
    isLoading,
    isEnd,
    pickFolderList,
    nowPickFolderHash,
    PickActions,
    AppErrorActions,
    NoticeModalActions,
    getIdTokenWT
  } = props;
  useEffect(() => {
    initPickList();
  }, []);

  const initPickList = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await PickActions.initOutfitList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const requestPickList = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await PickActions.getOutfitList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const changePickList = async folderHash => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await PickActions.changeOutfitListOfFolder({ idToken, folderHash });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleFolderChange = (key, newHash) => {
    if (nowPickFolderHash !== newHash) {
      changePickList(newHash);
    }
  };

  const handleFolderCreateBtnSubmit = async folderName => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    if (!folderName || folderName.trim().length === 0) return null;

    try {
      const { needCreative, success, hash } =
        await PickActions.createPickFolder({
          idToken,
          folderName
        });
      if (success) {
        changePickList(hash);
      } else if (needCreative) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_createFolderLimit" />
        });
      } else {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleFolderEditBtnSubmit = async ({ folderHash, newName }) => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    if (!newName || newName.trim().length === 0) return null;

    try {
      const { success } = await PickActions.editPickFolder({
        folderHash,
        newFolderName: newName,
        idToken
      });
      if (!success) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleFolderDeleteBtnSubmit = async ({ folderHash }) => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await PickActions.changeOutfitListOfFolder({
        idToken,
        folderHash: "all"
      });

      const { success } = await PickActions.deletePickFolder({
        folderHash,
        idToken
      });

      if (!success) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <PickListView
      list={outfitList}
      isLoading={isLoading}
      isEnd={isEnd}
      pickFolderList={pickFolderList}
      selectedFolderHash={nowPickFolderHash}
      onFolderChange={handleFolderChange}
      callNextListFn={requestPickList}
      onFolderCreateBtnSubmit={handleFolderCreateBtnSubmit}
      onFolderEditBtnSubmit={handleFolderEditBtnSubmit}
      onFolderDeleteBtnSubmit={handleFolderDeleteBtnSubmit}
    />
  );
}

export default withToken(
  withStore({
    stateMap: {
      pick: [
        "outfitList",
        "isLoading",
        "isEnd",
        "pickFolderList",
        "nowPickFolderHash"
      ]
    },
    dispatchMap: ["pick", "appError", "noticeModal"]
  })(PickList)
);
